import { Button, Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';
import { Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

import { CopyToClipboardButton } from '@components/ui/button';

import { Route } from '@/constants';

import { usePurchaseDetailsContext } from './purchase-details.context';

export const SupplierInfo = () => {
    const { data } = usePurchaseDetailsContext();

    const supplier = data?.data?.supplier;

    const supplierName = supplier?.name ?? '---';
    const supplierEmail = supplier?.email ?? '---';
    const supplierPhone = supplier?.phone_number ?? '---';
    const supplierAddress = supplier?.address ?? '---';
    const supplierSince = supplier?.created_at
        ? new Date(supplier.created_at).toLocaleDateString()
        : '---';

    const renderContactInfo = () => {
        if (!supplier) {
            return null;
        }

        return (
            <div className="space-y-4">
                <div className="flex items-center justify-between gap-3 rounded-lg bg-muted p-3">
                    <div className="flex items-center gap-3">
                        <Mail className="h-4 w-4 text-muted-foreground" />
                        <div className="min-w-0">
                            <p className="text-xs text-muted-foreground">
                                Email
                            </p>
                            <p className="truncate text-sm font-medium">
                                {supplierEmail}
                            </p>
                        </div>
                    </div>
                    <CopyToClipboardButton textToCopy={supplierEmail} />
                </div>

                <div className="flex items-center justify-between gap-3 rounded-lg bg-muted p-3">
                    <div className="flex items-center gap-3">
                        <Phone className="h-4 w-4 text-muted-foreground" />
                        <div className="min-w-0">
                            <p className="text-xs text-muted-foreground">
                                Phone
                            </p>
                            <p className="truncate text-sm font-medium">
                                {supplierPhone}
                            </p>
                        </div>
                    </div>
                    <CopyToClipboardButton textToCopy={supplierPhone} />
                </div>
            </div>
        );
    };

    const renderSupplierSince = () => {
        if (!supplier) {
            return null;
        }

        return (
            <div>
                <p className="text-xs font-semibold text-muted-foreground">
                    Supplier Since
                </p>
                <p className="mt-1 text-sm font-medium">{supplierSince}</p>
            </div>
        );
    };

    const renderSupplierName = () => {
        if (!supplier) {
            return <CardTitle className="text-xl">{supplierName}</CardTitle>;
        }
        return (
            <Link to={`${Route.SUPPLIERS}/${supplier.id}`}>
                <Button type={'button'} asChild variant="link" className="p-0">
                    <CardTitle className="text-xl">{supplierName}</CardTitle>
                </Button>
            </Link>
        );
    };

    return (
        <Card>
            <CardHeader>
                <div className="flex items-start justify-between">
                    <div>
                        {renderSupplierName()}
                        <p className="mt-1 text-xs text-muted-foreground">
                            {supplierAddress}
                        </p>
                    </div>
                </div>
            </CardHeader>
            <CardContent className="space-y-6">
                {renderSupplierSince()}

                {/* Contact Info */}
                {renderContactInfo()}
            </CardContent>
        </Card>
    );
};

SupplierInfo.displayName = 'SupplierInfo';
